import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { loadSentry } from './app/core/lazy-sentry';

// Error monitoring — like PostHog, only on the live advocad.app hosts so
// local/preview sessions never pollute the project. Loaded lazily so the
// SDK never delays first paint.
const host = window.location.hostname;
const isLiveHost = host === 'advocad.app' || host.endsWith('.advocad.app');
if (environment.sentry?.dsn && isLiveHost) {
  void loadSentry().then((Sentry) => {
    Sentry.init({
      dsn: environment.sentry.dsn,
      // Distributed tracing: sample page loads/route changes as transactions
      // and stamp `sentry-trace` + `baggage` on requests to OUR api only —
      // the API's Sentry continues the trace, so browser + backend appear as
      // one distributed trace.
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 0.2,
      tracePropagationTargets: [environment.apiBaseUrl],
    });
  });
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
